var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_415_3222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.724 9.47197C28.7427 9.7533 28.7427 10.036 28.7427 10.32C28.7427 18.996 22.1373 29 10.0627 29V28.9946C6.496 29 3.00267 27.9786 0 26.052C0.518667 26.1146 1.04 26.1453 1.56267 26.1466C4.52 26.1493 7.392 25.1573 9.716 23.3306C6.90667 23.2773 4.44267 21.4453 3.58267 18.7706C4.56667 18.96 5.58 18.9213 6.54667 18.6586C3.48267 18.04 1.28 15.348 1.28 12.2226C1.28 12.1946 1.28 12.1666 1.28 12.14C2.19333 12.6493 3.21467 12.9306 4.26 12.9613C1.37467 11.0346 0.484 7.1973 2.22667 4.1973C5.56 8.29863 10.4787 10.792 15.7573 11.0573C15.228 8.7773 15.952 6.38797 17.656 4.78397C20.3 2.2973 24.4587 2.4253 26.9453 5.0693C28.416 4.77997 29.8253 4.23997 31.1147 3.47597C30.624 4.99597 29.5987 6.28663 28.228 7.10797C29.5307 6.95197 30.8013 6.60397 32 6.0733C31.1187 7.39197 30.0093 8.54263 28.724 9.47197Z",
    fill: "white",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_3222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0bc6ae4ee468e3b4020710a9dff9a06d.svg";
export { ForwardRef as ReactComponent };